import { createSlice } from "@reduxjs/toolkit";

export const processSlice = createSlice({
  name: "process",
  initialState: {
    processTemplates: undefined
  },
  reducers: {
    setProcessTemplates: (state, action) => {
      state.processTemplates = action.payload;
    }
  }
});

// Action creators are generated for each case reducer function
export const { setProcessTemplates } = processSlice.actions;

export default processSlice.reducer;
